/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import { SlaveServerRawConfig } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

export class SlaveServerRawConfigConverter
  implements BodyConverter<SlaveServerRawConfig>
{
  public encode(
    model: SlaveServerRawConfig,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeSlaveServerRawConfig(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): SlaveServerRawConfig {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readSlaveServerRawConfig();
  }
}
